import { encode } from 'qss'

import { ProductDataProps } from '@unlikelystudio/react-abstract-components'

import getAlternateUrl from '~/utils/alternate-url'

export default function serializeJSONLD({
  name,
  description,
  images,
  path,
  currency,
  sku,
  mpn,
  variants,
}): ProductDataProps {
  const date = new Date()
  const priceValidUntil =
    new Date(date.setMonth(date.getMonth() + 3))
      .toISOString()
      ?.split('T')?.[0] ?? null

  return {
    name: name ?? null,
    brand: {
      name: 'Nina Ricci',
    },
    description: description ?? null,
    sku: sku ?? null,
    mpn: mpn ?? null,
    image: images?.map((image) => image?.src ?? null)?.filter(Boolean) ?? null,
    offers: variants?.map?.((variant, index) => {
      return {
        url: getAlternateUrl(
          `${path}${encode({ variant: variant?.title }, '?')}`,
        ),
        image: images?.[index]?.src ?? null,
        sku: variant?.sku ?? null,
        mpn: variant?.barcode ?? null,
        priceValidUntil,
        price: variant?.priceAmount ?? null,
        itemCondition: 'https://schema.org/NewCondition',
        availability: variant?.availableForSale
          ? 'https://schema.org/InStock'
          : 'https://schema.org/OutOfStock',
        priceCurrency: currency?.toUpperCase() ?? null,
      }
    }),
  }
}
